<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>
      Rental Investment Incomes
    </mat-card-title>
    <mat-card-subtitle><mat-error>Please add your Investment Assets or Liabilities here</mat-error></mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <ng-container *ngIf="investmentsFormArray.controls.length > 0">
      <div *ngFor="let investment of investmentsFormArray.controls; index as i">
        <div class="row mb-2" [formGroup]="investment">
          <div class="col-8">
            <strong>Property {{i + 1}}</strong>
            <mat-checkbox class="ms-3" formControlName="refinancing">Refinance</mat-checkbox>
            <mat-checkbox class="ms-3" formControlName="isNewInvestment" *ngIf="isHomeLoan">New Investment / Rent
            </mat-checkbox>
            <mat-checkbox class="ms-3" formControlName="interestOnly">Interest Only</mat-checkbox>
            <mat-checkbox class="ms-3" *ngIf="isHomeLoan" formControlName="useAsSecurity">Use as security</mat-checkbox>
          </div>

          <div class="col-4 text-end">
            <button type="button" mat-icon-button (click)="removeInvestment(i)" color="warn">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
        <div class="row font-80" [formGroup]="investment">
          <div class="col-4">
            <fmc-address-search
              [parentFormGroup]="investment"
              [mode]="'external'"
              [controlName]="'securityAddress'"
              [placeholderText]="'Address'"
              [toggleResetFormValues]="false"
              [allowTba]="true"
              [notRequired]="true"
            ></fmc-address-search>
          </div>
          <div class="col-2">
            <mat-form-field appearance="outline">
              <mat-label>Property type</mat-label>
              <mat-select placeholder="Property Type" formControlName="propertyType">
                <mat-option *ngFor="let type of propertyTypes" [value]="type.id">
                  {{type.text}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="investment.get('propertyType').value === 'unit'" style="font-size: 0.8em;">
              <mat-checkbox formControlName="isHighDensity" class="mt-2">More than 6 floors</mat-checkbox>
            </div>
          </div>
          <div class="col-2">
            <mat-form-field appearance="outline">
              <mat-label>Asset value</mat-label>
              <span class="me-1" matPrefix>$ </span>
              <input matInputCommified matInput placeholder="Asset Value" formControlName="assetValue">
              <mat-error>
                <app-validation-partial [formGroup]="investment" [fieldName]="'assetValue'"></app-validation-partial>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field appearance="outline">
              <mat-label>Loan limit</mat-label>
              <span class="me-1" matPrefix>$ </span>
              <input matInputCommified matInput placeholder="Loan Limit" formControlName="investmentLoanBalance">
              <mat-error *ngIf="investment.get('investmentLoanBalance')?.hasError('required')">
                Please enter a loan amount or zero if the property is unencumbered
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field appearance="outline"
              matTooltip="Enter the amount of this investment loan to be included in calculation of investment loan interest addback (negative gearing benefit)">
              <mat-label>Inv loan int addback</mat-label>
              <span class="me-1" matPrefix>$ </span>
              <input matInput matInputCommified placeholder="Inv Loan Int Addback" formControlName="invLoanIntAddback">
              <mat-error *ngIf="investment.get('invLoanIntAddback')?.hasError('required')">
                Please enter a loan amount or zero if the property is unencumbered
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row font-80" [formGroup]="investment">
          <div class="col-2">
            <mat-form-field appearance="outline">
              <mat-label>Rent period</mat-label>
              <mat-select placeholder="Rent period" formControlName="frequencyType">
                <mat-option [value]="'weekly'">Weekly</mat-option>
                <mat-option [value]="'monthly'">Monthly</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field appearance="outline">
              <mat-label>Rent</mat-label>
              <span class="me-1" matPrefix>$ </span>
              <input matInputCommified matInput placeholder="Rent" formControlName="rent">
              <mat-error class="ms-3">
                <ng-container *ngIf="investment?.controls.parties?.errors?.ownership && submitted">
                  The ownership percentages must equal 100
                </ng-container>
                <app-validation-partial [formGroup]="investment" [fieldName]="'rent'"></app-validation-partial>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field appearance="outline">
              <mat-label>Mth repayments</mat-label>
              <span class="me-1" matPrefix>$ </span>
              <input matInputCommified matInput placeholder="Mth repayments" formControlName="monthlyRepayments">
              <mat-error>
                <ng-container *ngIf="investment.get('monthlyRepayments')?.hasError('required')">
                  Please enter a repayment amount or zero if the property is unencumbered
                </ng-container>
                <app-validation-partial [formGroup]="investment" [fieldName]="'rent'"></app-validation-partial>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline">
              <mat-label>Select a lender</mat-label>
              <mat-select panelClass="full-width" placeholder="Select a lender" formControlName="creditProvider">
                <mat-option [value]="null">--- Not in list ---</mat-option>
                <mat-option *ngFor="let lender of allLenders" [value]="lender.partyRoleId">{{lender.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <app-ownership-allocation
          [forceDisplay]="true"
          [personList]="personList"
          [companyList]="companyList"
          [trustList]="trustList"
          [formGroup]="investment"
          [isFurtherAdvance]="isFurtherAdvance"
          [isSMSF]="isSMSF">
        </app-ownership-allocation>
        <hr>
      </div>
    </ng-container>
    <div class="row">
      <div class="col-sm-8">
        <button mat-raised-button name="addInvestment" class="fmc-button-primary" color="'primary'" type="button" (click)="addInvestment()">Add New
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
